module.exports = __webpack_public_path__ + "img/BH.90abd3f9.svg";